type ProductCategoryMeta = {
  productCategory: string;
  title: string;
  description: string;
  canonical: string;
};

export const productCategoryMetaTags: Record<string, ProductCategoryMeta> = {
  ["all-products"]: {
    // 1525
    productCategory: "allProducts",
    title: "Quality Building Materials for Every Project",
    description:
      "Shop premium building materials with durable, reliable products designed to support all construction needs. Easy browsing and fast availability.",
    canonical:
      "https://geminiuae.com/product-category/all-products",
  },
  ["access-panel"]: {
    // 965
    productCategory: "accessPanel",
    title: "Durable Access Panels for Every Project",
    description:
      "Browse high-quality access panels built for strength, convenience, and easy installation—perfect for ceilings, walls, and maintenance spaces.",
    canonical:
      "https://geminiuae.com/product-category/access-panel",
  },
  ["ceiling-system"]: {
    // 68
    productCategory: "ceilingSystem",
    title: "Premium Ceiling Systems for Modern Spaces",
    description:
      "Discover durable, high-performance ceiling systems designed for smooth installation, aesthetic appeal, and long-lasting structural quality.",
    canonical:
      "https://geminiuae.com/product-category/ceiling-system",
  },
  ["cement-board"]: {
    // 86
    productCategory: "cementBoard",
    title: "High-Strength Cement Boards for Construction",
    description:
      "Explore premium cement boards built for durability, moisture resistance, and versatile use in interior and exterior construction projects.",
    canonical:
      "https://geminiuae.com/product-category/cement-board",
  },
  ["drywall-partition"]: {
    // 15
    productCategory: "drywallPartition",
    title: "Reliable Drywall Partition Systems UAE",
    description:
      "Shop durable drywall partition systems designed for easy installation, strong performance, and versatile use in residential and commercial spaces.",
    canonical:
      "https://geminiuae.com/product-category/drywall-partition",
  },
  ["d-wall-partition-ceiling-accessories"]: {
    // 80
    productCategory: "dWallPartitionCeilingAccessories",
    title: "Partition & Ceiling Accessories Collection",
    description:
      "Find high-quality accessories for partition and ceiling systems, designed to enhance stability, performance, and installation efficiency.",
    canonical:
      "https://geminiuae.com/product-category/d-wall-partition-ceiling-accessories",
  },
  ["hardware"]: {
    // 1378
    productCategory: "hardware",
    title: "Quality Hardware for Every Construction Need",
    description:
      "Browse durable, reliable hardware essentials designed to support building projects with strength, precision, and long-lasting performance.",
    canonical:
      "https://geminiuae.com/product-category/hardware",
  },
  ["insulation"]: {
    // insulation
    productCategory: "insulation",
    title: "Premium Insulation Solutions for Buildings",
    description:
      "Discover high-performance insulation materials that enhance energy efficiency, reduce noise, and provide long-lasting protection for any project.",
    canonical:
      "https://geminiuae.com/product-category/insulation",
  },
};